import { fromJS } from 'immutable';

import { DemandReportsActionTypes as actionTypes } from './demandReportsTypes';

const initialState = fromJS({
	data: {},
	demandReportData: {},
	failure: '',
	isLoading: false
});

export default (state = initialState, action: any) => {
	switch (action.type) {
		default:
			return state;

		case actionTypes.DEMAND_REPORT_GET_REPORTS_SUCCESS: {
			return state
				.setIn(['demandReportData'], action.payload)
				.setIn(['demandReportDataFailure'], false);
		}
		case actionTypes.DEMAND_REPORT_GET_REPORTS_FAILURE: {
			return state.setIn(
				['demandReportDataFailure'],
				action.payload.message
			);
		}
		case actionTypes.DEMAND_REPORT_RESET_DEMAND_REPORT_FAILURE: {
			return state.setIn(['demandReportDataFailure'], false);
		}

		case actionTypes.DEMAND_REPORT_GET_ALL_REPORTS_SUCCESS: {
			return state
				.setIn(['demandReportAllReports'], action.payload)
				.setIn(['demandReportAllReportsNoReports'], false);
		}

		case actionTypes.DEMAND_REPORT_GET_ALL_REPORTS_NO_REPORTS: {
			return state.setIn(['demandReportAllReportsNoReports'], true);
		}
	}
};
